var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "px-10 my-3", attrs: { fluid: "" } },
    [
      _c(
        "portal",
        { attrs: { to: "page-title" } },
        [
          _c("v-breadcrumbs", {
            attrs: {
              items: [
                { text: _vm.$tc("labels.general", 2), disabled: false },
                { text: _vm.$tc("labels.holiday", 2), disabled: false }
              ]
            },
            scopedSlots: _vm._u([
              {
                key: "divider",
                fn: function() {
                  return [
                    _c("v-icon", { attrs: { size: "8" } }, [
                      _vm._v("\n          far fa-chevron-right\n        ")
                    ])
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _c(
        "v-card",
        { attrs: { id: "holidays" } },
        [
          _c(
            "v-row",
            { staticClass: "actions", attrs: { "no-gutters": "" } },
            [
              _c(
                "v-col",
                [
                  _c("v-text-field", {
                    staticClass:
                      "name-filter pt-3 pb-1 ml-4 extra-dense-text-field d-inline-block",
                    attrs: {
                      "append-icon": _vm.filters.name ? "" : "fal fa-search",
                      clearable: !!_vm.filters.name,
                      dense: "",
                      "hide-details": "",
                      placeholder: _vm.$t("labels.searchByName"),
                      solo: ""
                    },
                    model: {
                      value: _vm.filters.name,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.filters,
                          "name",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "filters.name"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("v-data-table", {
            directives: [
              {
                name: "resize",
                rawName: "v-resize.quiet",
                value: _vm.onWindowResized,
                expression: "onWindowResized",
                modifiers: { quiet: true }
              }
            ],
            attrs: {
              "fixed-header": "",
              headers: _vm.headers,
              "header-props": { sortIcon: "fa fa-arrow-up" },
              "hide-default-footer": "",
              items: _vm.paginatedHolidays,
              "items-per-page": _vm.pagination.itemsPerPage,
              "must-sort": "",
              "single-select": "",
              "sort-by": _vm.sort.by,
              "sort-desc": _vm.sort.desc
            },
            on: {
              "update:sortBy": function($event) {
                return _vm.$set(_vm.sort, "by", $event)
              },
              "update:sort-by": function($event) {
                return _vm.$set(_vm.sort, "by", $event)
              },
              "update:sortDesc": function($event) {
                return _vm.$set(_vm.sort, "desc", $event)
              },
              "update:sort-desc": function($event) {
                return _vm.$set(_vm.sort, "desc", $event)
              }
            },
            scopedSlots: _vm._u([
              {
                key: "item",
                fn: function(ref) {
                  var item = ref.item
                  var tableHeaders = ref.headers
                  return [
                    _c(
                      "tr",
                      {
                        class: item.obsolete ? "obsolete" : "",
                        on: {
                          mouseenter: function($event) {
                            _vm.hoveredItem = item
                          },
                          mouseleave: function($event) {
                            _vm.hoveredItem = null
                          }
                        }
                      },
                      [
                        _vm._l(tableHeaders, function(header) {
                          return _c(
                            "td",
                            { key: header.value, staticClass: "text-start" },
                            [
                              header.value === "partakeInScheduling"
                                ? [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "d-inline-block",
                                        style: { "min-width": "140px" }
                                      },
                                      [
                                        item.partakeInScheduling
                                          ? _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  color: "success",
                                                  small: ""
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  fas fa-check-circle\n                "
                                                )
                                              ]
                                            )
                                          : _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  color: "grey",
                                                  small: ""
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  far fa-times-circle\n                "
                                                )
                                              ]
                                            )
                                      ],
                                      1
                                    )
                                  ]
                                : _c(
                                    "span",
                                    {
                                      staticClass:
                                        "grey--text text--darken-3 text-truncate d-block",
                                      style: { width: header.width + "px" },
                                      attrs: { title: item[header.value] }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(item[header.value]) +
                                          "\n            "
                                      )
                                    ]
                                  )
                            ],
                            2
                          )
                        }),
                        _c(
                          "v-speed-dial",
                          {
                            staticClass: "mt-6 holiday-dial",
                            attrs: {
                              absolute: "",
                              value:
                                _vm.hoveredItem &&
                                _vm.hoveredItem.name === item.name,
                              right: "",
                              direction: "left",
                              transition: "slide-x-reverse-transition"
                            }
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "edit",
                                attrs: {
                                  fab: "",
                                  height: "30",
                                  width: "30",
                                  title: _vm.$t("labels.editHoliday")
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.openHolidayDialog(item)
                                  }
                                }
                              },
                              [
                                _c("v-icon", { attrs: { small: "" } }, [
                                  _vm._v(
                                    "\n                fal fa-pencil\n              "
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      2
                    )
                  ]
                }
              },
              {
                key: "footer",
                fn: function() {
                  return [
                    _c("v-pagination", {
                      staticClass: "py-4 footer",
                      attrs: {
                        color: "secondary",
                        length: _vm.numberOfPages,
                        "next-icon": "far fa-chevron-right",
                        "prev-icon": "far fa-chevron-left",
                        "total-visible": _vm.pagination.maxPaginationControls
                      },
                      model: {
                        value: _vm.pagination.currentPage,
                        callback: function($$v) {
                          _vm.$set(_vm.pagination, "currentPage", $$v)
                        },
                        expression: "pagination.currentPage"
                      }
                    })
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _vm.showHolidayDialog
        ? _c(
            "v-dialog",
            {
              attrs: {
                persistent: "",
                width: "500px",
                value: _vm.showHolidayDialog
              }
            },
            [
              _c(
                "v-card",
                { staticClass: "pa-0", attrs: { id: "holiday" } },
                [
                  _c(
                    "v-card-title",
                    { staticClass: "body-2 d-block mb-2" },
                    [
                      _c("span", { staticClass: "body-2 font-weight-medium" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("labels.editHoliday") +
                                " - " +
                                _vm.selectedHoliday.name
                            ) +
                            "\n        "
                        )
                      ]),
                      _c(
                        "v-btn",
                        {
                          staticClass: "float-right mt-n1",
                          attrs: { disabled: _vm.saving, icon: "", small: "" },
                          on: { click: _vm.closeHolidayDialog }
                        },
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v("\n            fal fa-times\n          ")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    { staticClass: "px-0" },
                    [
                      _c("ValidationObserver", {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var invalid = ref.invalid
                                var passes = ref.passes
                                return [
                                  _c(
                                    "v-form",
                                    { staticClass: "holiday" },
                                    [
                                      _c(
                                        "v-container",
                                        { staticClass: "py-0 px-6" },
                                        [
                                          _c(
                                            "v-row",
                                            { attrs: { dense: "" } },
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("v-switch", {
                                                    staticClass:
                                                      "d-inline-block mt-0 mb-4",
                                                    attrs: {
                                                      color: "success",
                                                      dense: "",
                                                      inset: "",
                                                      "hide-details": ""
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "label",
                                                          fn: function() {
                                                            return [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "mr-4 body-2 grey--text text--darken-3",
                                                                  attrs: {
                                                                    title: _vm.$t(
                                                                      "labels.observed"
                                                                    )
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "labels.observed"
                                                                        )
                                                                      ) +
                                                                      "\n                      "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          },
                                                          proxy: true
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                    model: {
                                                      value:
                                                        _vm.selectedHoliday
                                                          .partakeInScheduling,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.selectedHoliday,
                                                          "partakeInScheduling",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "selectedHoliday.partakeInScheduling"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c("v-divider"),
                                      _c(
                                        "v-row",
                                        { attrs: { dense: "" } },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass:
                                                "text-right pb-0 pt-4 px-8",
                                              attrs: { cols: "12" }
                                            },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "mr-4",
                                                  attrs: {
                                                    disabled: _vm.saving,
                                                    text: ""
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.closeHolidayDialog
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.$t("labels.cancel")
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "submit",
                                                  attrs: {
                                                    color: "secondary",
                                                    disabled:
                                                      invalid || _vm.saving
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return passes(_vm.update)
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm.saving
                                                    ? _c(
                                                        "v-progress-circular",
                                                        {
                                                          attrs: {
                                                            color:
                                                              "primary lighten-2",
                                                            indeterminate: "",
                                                            size: "22",
                                                            width: "2"
                                                          }
                                                        }
                                                      )
                                                    : _c("span", [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "labels.save"
                                                              )
                                                            ) +
                                                            "\n                  "
                                                        )
                                                      ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c("v-spacer")
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3343364638
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }